import React, { useState, useEffect } from "react";
import { ChevronLeft, ChevronRight, Info, X } from "lucide-react";
import { format, startOfWeek, addDays, isToday, parseISO } from "date-fns";
import { getData } from "../../../api/api";
import { useParams } from "react-router-dom";
import { Button, Form, Input, notification, Select, Space } from "antd";
import { Option } from "antd/es/mentions";
import { CreateMenu, DeleteMenu, GetAllDishs, GetDishsBySize, UpdateMenu } from "../../../api/MonkService";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";

const MonkMenuFood = () => {
  const [selectedMeal, setSelectedMeal] = useState(null);
  const [CreateNewDish, setCreateNewDish] = useState(null)
  const [currentDate, setCurrentDate] = useState(new Date());
  const [dish, setDish] = useState([])
  const [menuData, setMenuData] = useState([]);
  const [menuID, setMenuID] = useState()
  const [Edit, setEdit] = useState(false);
  const [form] = Form.useForm()
  const [Loading, setLoading] = useState(false);
  const getDishs = () => {
    try {
      GetDishsBySize(1000).then(res => {
        if (res.status === 200) {
          setDish(res.data.data)
        }
      })
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    getDishs();
  }, []);
  //delete Dish
  const deleteDish = (id) => {
    DeleteMenu(id).then((res) => {
      console.log(res)
      notification.success({
        message: "Delete Successfully"
      });
      window.location.reload();
    }).catch(err => {
      console.log(err.response)
      notification.error({
        message: `${err.response.data.message}`
      })
    });
  }
  // Function to update currentDate after fetching data
  const updateCurrentDate = (menus) => {
    if (menus.length > 0) {
      // Assuming cookDate is in 'yyyy-MM-dd' format
      const firstCookDate = menus[0].cookDate;
      setCurrentDate(parseISO(firstCookDate));
    }
  };

  useEffect(() => {
    getData("/menu").then((response) => {
      const menuItems = response.data.data;
      console.log("Fetched menu items:", menuItems);
      setMenuData(menuItems);
      updateCurrentDate(menuItems);
    });
  }, []);

  // Recalculate the start of the week whenever currentDate changes
  const startOfCurrentWeek = startOfWeek(currentDate, { weekStartsOn: 1 });

  const openMealDetails = (meal) => {
    setSelectedMeal(meal);
    console.log(meal.data.dishes)
    setMenuID(meal.data.id)
    form.setFieldsValue({
      menuName: meal?.data?.menuName,
      cookDate: meal?.cookDate,
      dishs: meal?.data.dishes.map(dish => ({ dishName: dish.name }))
    });
  };

  const openCreateNew = (meal) => {
    setCreateNewDish(meal);
    console.log(meal)

    form.setFieldsValue({
      cookDate: meal?.cookDate,

    });
  };

  const closeCreateNew = () => {
    setCreateNewDish(null);
    form.resetFields();
  };

  const closeMealDetails = () => {
    setSelectedMeal(null);
    setEdit(false)
  };

  //onFinish
  const onFinish = async (values) => {
    setLoading(true);
    const formData = new FormData();
    formData.append('menuName', values.menuName);
    formData.append('cookDate', values.cookDate);
    if (values.dishs && values.dishs.length > 0) {
      values.dishs.forEach(dish => {
        formData.append('dishName', dish.dishName);
      });
    } else {
      notification.error({
        message: "At least one dish is required."
      });
      setLoading(false);
      return;
    }
    CreateMenu(formData).then((res) => {
      console.log(res);
      notification.success({
        message: "Success creating Menu"
      });
      form.resetFields();
      getData("/menu").then((response) => {
        setMenuData(response.data.data);
        updateCurrentDate(response.data.data);
      });
      setLoading(false);
      setCreateNewDish(null);
    }).catch(err => {
      console.log(err.response)
      notification.error({
        message: `${err.response.data.message}`
      })
      setLoading(false);
    });
  }

  const onFinishUpdate = async (values) => {
    setLoading(true);
    const formData = new FormData();
    formData.append('menuName', values.menuName);
    formData.append('cookDate', values.cookDate);
    if (values.dishs && values.dishs.length > 0) {
      values.dishs.forEach(dish => {
        formData.append('dishName', dish.dishName);
      });
    } else {
      notification.error({
        message: "At least one dish is required."
      });
      return;
    }
    UpdateMenu(menuID, formData).then((res) => {
      console.log(res);
      notification.success({
        message: "Success update activity"
      });
      form.resetFields();
      getData("/menu").then((response) => {
        setMenuData(response.data.data);
        updateCurrentDate(response.data.data);
      });
      setSelectedMeal(null);
      setLoading(false);
      setEdit(false)

    }).catch(err => {
      console.log(err.response)
      notification.error({
        message: `${err.response.data.message}`
      })
      setLoading(false);
    });
  }


  // Cập nhật danh sách các loại món ăn
  const dishTypes = ["Breakfast", "Lunch", "Dinner"];
  return (
    <div className="h-[96.5vh] bg-[#f9f7f4]">
      <div className="max-w-[1200px] mx-auto p-4">
        {/* Header */}
        <div className="flex items-center justify-between mb-6">
          <h1 className="text-xl font-medium text-[#725b53]">
            Weekly Menu from {format(startOfCurrentWeek, "dd.MM.yyyy")} to{" "}
            {format(addDays(startOfCurrentWeek, 6), "dd.MM.yyyy")}
          </h1>

          <div className="flex items-center gap-2">
            <button
              className="p-2 hover:bg-gray-200 rounded"
              onClick={() => setCurrentDate(addDays(currentDate, -7))}
            >
              <ChevronLeft className="w-5 h-5 text-gray-600" />
            </button>
            <button
              className="p-2 hover:bg-gray-200 rounded"
              onClick={() => setCurrentDate(addDays(currentDate, 7))}
            >
              <ChevronRight className="w-5 h-5 text-gray-600" />
            </button>
          </div>
        </div>

        {/* Menu Grid */}
        <div className="overflow-x-auto">
          <div className="min-w-[1000px]">
            {/* Days Header */}
            <div className="grid grid-cols-[150px_repeat(7,1fr)] bg-[#e8e1d9]">
              <div className="p-2 font-medium text-[#725b53] border-r border-[#d3c7bc]">
                Dish Type
              </div>
              {[...Array(7)].map((_, index) => {
                const dayDate = addDays(startOfCurrentWeek, index);
                const dayName = format(dayDate, "EEEE");
                return (
                  <div
                    key={index}
                    className="p-2 font-medium text-center text-[#725b53] border-r border-[#d3c7bc]"
                  >
                    <div>{dayName} </div>
                    <div>{format(dayDate, "dd.MM.yyyy")} </div>

                  </div>
                );
              })}
            </div>

            {/* Meal Slots */}
            {dishTypes.map((dishType) => (
              <div
                key={dishType}
                className="grid grid-cols-[150px_repeat(7,1fr)] border-b border-[#d3c7bc]"
              >
                <div className="p-2 text-sm text-[#725b53] border-r border-[#d3c7bc] bg-[#f3efe9]">
                  {dishType}
                </div>
                {[...Array(7)].map((_, index) => {
                  const currentDayDate = addDays(startOfCurrentWeek, index);
                  const dateStr = format(currentDayDate, "yyyy-MM-dd");
                  const isBeforeCurrentDate = currentDayDate < new Date().setDate(new Date().getDate() - 1);
                  // Find the menu for the current date
                  const menuForDate = menuData.find(
                    (menuItem) => menuItem.cookDate === dateStr && menuItem.menuName === dishType
                  );

                  // Tìm các món cho loại món ăn hiện tại
                  let meals = [];
                  if (menuForDate) {
                    meals = menuForDate.dishes; // Lấy tất cả các món ăn
                  }
                  const isTodayFlag = isToday(currentDayDate);

                  return (

                    <div
                      key={index}
                      className={`p-2 text-sm border-r border-[#d3c7bc] min-h-[80px] max-h-[200px] overflow-y-auto ${isTodayFlag ? "bg-yellow-200" : ""} ${isBeforeCurrentDate ? "bg-gray-300 opacity-50 cursor-not-allowed" : ""}`}
                      onClick={
                        () => !isBeforeCurrentDate && meals.length === 0 && openCreateNew({ cookDate: dateStr })
                      }
                    >


                      {meals.map((meal) => (
                        <button
                          key={meal.id}
                          onClick={() =>
                            openMealDetails({ ...meal, cookDate: dateStr, data: menuForDate })
                          }
                          className={`flex items-start gap-2 w-full text-left hover:bg-[#e8e1d9] p-1 rounded transition-colors `}
                        >
                          <span className="flex-1">{meal.name}</span>
                        </button>
                      ))
                      }
                    </div>
                  );
                })}
              </div>
            ))}
          </div>
        </div >

        {/* Meal Details Popup */}
        {
          Edit ? (
            <>
              {selectedMeal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
                  <div className="bg-white rounded-lg shadow-lg p-6 max-w-md w-full">
                    <div className="flex justify-between items-start mb-4">
                      <h2 className="text-xl font-semibold text-[#725b53]">
                        Update Menu
                      </h2>
                      <button
                        onClick={closeMealDetails}
                        className="text-gray-500 hover:text-gray-700"
                      >
                        <X className="w-6 h-6" />
                      </button>
                    </div>
                    <div className="space-y-2 text-[#725b53]">
                      <Form
                        form={form}
                        onFinish={onFinishUpdate}
                      >
                        <Form.Item name={"menuName"} label="Menu Name"
                          rules={[
                            {
                              required: true,
                              message: 'Requiring name',
                            },
                          ]}
                        >
                          <Select
                            placeholder="Choose Menu Name "
                          >
                            <Option key={1} value={"Breakfast"}>
                              Breakfast
                            </Option>
                            <Option key={2} value={"Lunch"}>
                              Lunch
                            </Option>
                            <Option key={3} value={"Dinner"}>
                              Dinner
                            </Option>
                          </Select>
                        </Form.Item>
                        <Form.List name="dishs" >
                          {(fields, { add, remove }) => (
                            <>
                              {fields.map(({ key, name, ...restField }) => (
                                <Space key={key} style={{ display: 'flex', marginBottom: 8 }} align="baseline">
                                  <Form.Item
                                    {...restField}
                                    name={[name, 'dishName']}
                                    rules={[{ required: true, message: 'Requiring dish' }]}
                                  >
                                    <Select
                                      style={{ width: '350px' }}
                                      placeholder="Choose Dish "
                                    >
                                      {dish.map((item) => (
                                        <Option key={item.id} value={item.name}>
                                          {item.name}
                                        </Option>
                                      ))}

                                    </Select>
                                  </Form.Item>
                                  <MinusCircleOutlined onClick={() => remove(name)} />
                                </Space>
                              ))}
                              <Form.Item>
                                <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                                  Add More Dish
                                </Button>
                              </Form.Item>
                            </>
                          )}
                        </Form.List>
                        <Form.Item name={"cookDate"} label="Cook Date" rules={[{ required: true, message: 'Requiring date' }]}>
                          <Input disabled
                          />
                        </Form.Item>
                        <Form.Item>
                          <Button block type="primary" htmlType="submit" loading={Loading}>
                            {Loading ? "Processing..." : "Confirm Update"}
                          </Button>
                        </Form.Item>
                      </Form>
                    </div>
                  </div>
                </div>
              )}
            </>
          ) : (
            <>
              {selectedMeal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
                  <div className="bg-white rounded-lg shadow-lg p-6 max-w-md w-full">
                    <div className="flex justify-between items-start mb-4">
                      <h2 className="text-xl font-semibold text-[#725b53]">
                        {selectedMeal.name}
                      </h2>
                      <button
                        onClick={closeMealDetails}
                        className="text-gray-500 hover:text-gray-700"
                      >
                        <X className="w-6 h-6" />
                      </button>
                    </div>
                    <div className="space-y-2 text-[#725b53]">
                      <p>
                        <strong>Dish Type:</strong> {selectedMeal.dishTypeName}
                      </p>
                      <p>
                        <strong>Date:</strong> {selectedMeal.cookDate}
                      </p>
                      <p>
                        <strong>Note:</strong> {selectedMeal.note || "No notes"}
                      </p>
                      <Button
                        onClick={() => setEdit(true)}
                        className="text-blue-500 hover:text-blue-700"
                        style={{ marginRight: 50 }}
                      >
                        Update
                      </Button>
                      <Button
                        onClick={() => deleteDish(menuID)}
                        className="text-red-500 hover:text-red-700"
                      >
                        Delete
                      </Button>
                    </div>
                  </div>
                </div>
              )}
            </>)
        }


        {
          CreateNewDish && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4">
              <div className="bg-white rounded-lg shadow-lg p-6 max-w-md w-full">
                <div className="flex justify-between items-start mb-4">
                  <h2 className="text-xl font-semibold text-[#725b53]">
                    Create New Menu
                  </h2>
                  <button
                    onClick={closeCreateNew}
                    className="text-gray-500 hover:text-gray-700"
                  >
                    <X className="w-6 h-6" />
                  </button>
                </div>
                <div className="space-y-2 text-[#725b53]">
                  <Form
                    form={form}
                    onFinish={onFinish}
                  >
                    <Form.Item name={"menuName"} label="Menu Name"
                      rules={[
                        {
                          required: true,
                          message: 'Requiring name',
                        },
                      ]}
                    >
                      <Select
                        placeholder="Choose Menu Name "
                      >
                        <Option key={1} value={"Breakfast"}>
                          Breakfast
                        </Option>
                        <Option key={2} value={"Lunch"}>
                          Lunch
                        </Option>
                        <Option key={3} value={"Dinner"}>
                          Dinner
                        </Option>
                      </Select>
                    </Form.Item>
                    <Form.Item name={"cookDate"} label="Cook Date" rules={[{ required: true, message: 'Requiring date' }]}>
                      <Input disabled
                      />
                    </Form.Item>

                    <Form.List name="dishs" >
                      {(fields, { add, remove }) => (
                        <>
                          {fields.map(({ key, name, ...restField }) => (
                            <Space key={key} style={{ display: 'flex', marginBottom: 8 }} align="baseline">
                              <Form.Item
                                {...restField}
                                name={[name, 'dishName']}
                                rules={[{ required: true, message: 'Requiring dish' }]}
                              >
                                <Select
                                  style={{ width: '350px' }}
                                  placeholder="Choose Dish "
                                >
                                  {dish.map((item) => (
                                    <Option key={item.id} value={item.name}>
                                      {item.name}
                                    </Option>
                                  ))}

                                </Select>
                              </Form.Item>
                              <MinusCircleOutlined onClick={() => remove(name)} />
                            </Space>
                          ))}
                          <Form.Item>
                            <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                              Add More Dish
                            </Button>
                          </Form.Item>
                        </>
                      )}
                    </Form.List>
                    <Form.Item >
                      <Button block type="primary" htmlType="submit" loading={Loading}>
                        {Loading ? "Loading" : "Save"}
                      </Button>
                    </Form.Item>
                  </Form>
                </div>
              </div>
            </div>
          )
        }
      </div >
    </div>
  );
}

export default MonkMenuFood
